import React from "react";

import { css } from "@emotion/react";

import { CSS_MQ } from "../../styles/breakpoints";
import { ImageGalleryRowType } from "@swo/storefront";

import cn from "classnames";
import { ContentfulImage2 } from "../_shared-components/image-related/ContentfulImage2";
import { ContentContainer } from "../_shared-components/arrangement/Container";

export function ImageGalleryRow(
  props: Omit<ImageGalleryRowType, "__typename"> & {
    onClick: (idx: number) => void;
    width: "full" | "content";
    isLast: boolean;
  },
) {
  const imagesCount = props.imagesCollection.length;

  const Content = (
    <div
      className={cn(imagesCount === 1 ? "full" : "half", { "last-row": props.isLast })}
      css={css`
        display: grid;

        ${CSS_MQ.atMostXs} {
          grid-row-gap: 5px;
        }

        ${CSS_MQ.atLeastSm} {
          grid-column-gap: 5px;

          &.full {
            grid-template-columns: 100%;
          }

          &.half {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }

          &:not(.last-row) {
            margin-bottom: 5px;
          }
        }
      `}
    >
      {props.imagesCollection.map((i, idx) => (
        <div
          key={i.url}
          className="u-relative"
          css={css`
            width: 100%;
            height: 100%;
            overflow: hidden;
            display: flex;
          `}
        >
          <ContentfulImage2
            assetId={i.sys.id}
            onClick={() => props.onClick(idx)}
            contentfulUrl={i.url}
            loading={"lazy"}
            sizes={
              props.width === "content"
                ? imagesCount === 1
                  ? "(max-width: 575px) 100vw, (max-width: 991px) 800px, 1400px"
                  : "(max-width: 575px) 100vw, (max-width: 991px) 400px, 740px"
                : imagesCount === 1
                  ? "100vw"
                  : "50vw"
            }
            alt={i.description || i.title}
            css={css`
              @media (pointer: fine) {
                transition: transform 0.25s ease-out;
                transform: scale(1);

                &:hover {
                  transition: transform 0.25s ease-out;
                  transform: scale(1.02);
                }
              }

              width: 100%;
              height: 100%;
              object-fit: cover;
            `}
            withTransparency={false}
            cropping={undefined}
          />
        </div>
      ))}
    </div>
  );

  if (props.width === "content") {
    return <ContentContainer>{Content}</ContentContainer>;
  } else {
    return Content;
  }
}
